import { useEffect, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Rabbit } from "../api/types";
import exp from "../components/exp-table.json"
import useSound from 'use-sound';

const findLevel = (xp:number) => {
    var experience: { [key:string] : number} = exp
    var returnLevel = 0
    var objKeys = Object.keys(experience)
    for(var e in objKeys){
      const expNumber = Number(experience[objKeys[e]])
      if(expNumber <= xp){
        returnLevel = Number(objKeys[e])
      }
    }
    return returnLevel;
  }
  const nextLevel = (xp:number):number => {
    var experience: { [key:string] : number} = exp
    var returnLevel = 0
    var objKeys = Object.keys(experience)
    for(var e in objKeys){
      const expNumber = Number(experience[objKeys[e]])
      if(expNumber <= xp){
        returnLevel = Number(objKeys[e])
      }
    }
    return experience[objKeys[returnLevel+1]];
  }
   
const RabbitItem = ({ rabbitObj, isSelected, toggleSelected, nextSpin, isSpinning} : { rabbitObj:Rabbit, isSelected:boolean, toggleSelected:(rabbit:Rabbit) => void,nextSpin: any, isSpinning: any}) => {
    const rabbit = rabbitObj
    rabbit.nextLevel = nextLevel(rabbit?.exp)
    const expProgress = Math.ceil((rabbit?.exp*100)/rabbit?.nextLevel)
    const spins_remaining = (rabbit?.spins_remaining) ? rabbit?.spins_remaining : 0
    const availableSpins = (spins_remaining > 1) ? `${spins_remaining} spins` : `${spins_remaining} spin`
    const availableSpin = (rabbit?.available === true) ? `${availableSpins} available` : `Next spin at ${nextSpin.long}`
    return (
        <div className={`Gachapon--Selector--Item ${(isSelected)? "active" : ""}  ${(rabbit.lastRoyalties < 4)? "notavailable" : ""} ${(rabbit.spins_remaining === 0)? "notavailable" : ""}`}  >
            <div className="Gachapon--Selector--Item--Image">
                <img src={rabbit?.metadata?.image} alt="" />
                <div className="Gachapon--Selector--Item--Lvl">LVL{findLevel(rabbit.exp)}</div>
            </div>
            <div className="Gachapon--Selector--Item--Title">
                
                <div className="Gachapon--Selector--Item--Name">{rabbit?.metadata?.name}</div>
                {(rabbit.lastRoyalties < 4) ? <div className={`Gachapon--Selector--Item--Available`}>0% ROYALTIES</div> : <div className={`Gachapon--Selector--Item--Available ${(rabbit?.available !== true) ? "": `n-a`} `} dangerouslySetInnerHTML={{ __html: availableSpin}}></div>}
            </div>
            <div className="Gachapon--Selector--Item--Exp">
                <span className="Gachapon--Selector--XP--Progress" style={{"width":expProgress + "%"}}></span>
                <span className="Gachapon--Selector--XP--Level">Exp. {(rabbit) ? rabbit.exp : 0} / {(rabbit) ? rabbit.nextLevel : 0} </span>
            </div>
            { (spins_remaining === -1) ? null : <button className='Gachapon--Selector--Footer' onClick={() => {toggleSelected(rabbit);  }}>SELECT RABBIT</button> }
            {isSpinning ? <span className='Gachapon--Selector--Item--Spinning'>Spinning...</span> : null}
        </div>
    )
}

const RabbitSelector = ({showSelector, rabbits, hideSelector, selectRabbit, nextSpin, spinAll, spinRabbit, spinRabbitHistory}: {showSelector: boolean, rabbits: any, hideSelector: () => void, selectRabbit: (rabbit:Rabbit | undefined) => void, nextSpin: string, spinAll: (rabbits:any) => void, spinRabbit: Rabbit | undefined, spinRabbitHistory: any}) => {
    const [isVisible, setIsVisible] = useState<boolean>()
    const [isSpinnAll, setSpinAll] = useState<boolean>(false)
    const [selectedRabbit, setSelectedRabbit] = useState<Rabbit>()
    const [clickSound, clickSoundData] = useSound('/audio/click.mp3', { volume: 0.03 });
    const [sortBy, setSortBy] = useState<string>("spins")
    const [sortedRabbits, setSortedRabbits] = useState<any>([])

    useEffect(() => {
        if(rabbits){
            var rabbitSort = rabbits.filter((r:any) => true).map((r:any) => { r.spins_remaining = (r.lastRoyalties < 8) ? 0 :  r.spins_remaining ; return r;  })
            if(sortBy==="levels"){
                rabbitSort.sort((a:any, b:any) => { return a.exp - b.exp})
            }
            if(sortBy==="spins"){
                rabbitSort.sort((a:any, b:any) => { return b.spins_remaining - a.spins_remaining})
            }
            setSortedRabbits(rabbitSort)
        }
        setIsVisible(showSelector)
    }, [showSelector])

    useEffect(() => {
        
    }, [selectedRabbit])
    

    useEffect(() => {
        if(rabbits){
            var rabbitSort = rabbits.filter((r:any) => true).map((r:any) => { r.spins_remaining = (r.lastRoyalties < 8) ? 0 :  r.spins_remaining ; return r;  })
            if(sortBy==="levels"){
                rabbitSort.sort((a:any, b:any) => { return a.exp - b.exp})
            }
            if(sortBy==="spins"){
                rabbitSort.sort((a:any, b:any) => { return b.spins_remaining - a.spins_remaining})
            }
            setSortedRabbits(rabbitSort)
        }
    }, [sortBy, rabbits])

    
    

    return (
        <div className={`Gachapon--Selector ${(isVisible) ? "show" : ""}`}>
            <div className="Gachapon--Selector--Container">
                <div className="Gachapon--Selector--Bar">
                    <div className="Gachapon--Selector--Bar-Sort">
                        <span className='spin-all' onClick={() => { setSpinAll(!isSpinnAll); setSortBy("spins")  }}>Spin {isSpinnAll ? "single" : "all"}</span>
                        {!isSpinnAll ? <span className='Gachapon--Selector--Bar-Title'>Sort by:</span> : null }
                         {!isSpinnAll ?<span className={`${sortBy==="spins"? "active" : ""}`} onClick={() => { setSortBy("spins") }}>Available Spins</span> : null }
                         {!isSpinnAll ?<span className={`${sortBy==="levels"? "active" : ""}`} onClick={() => { setSortBy("levels") }}>Level</span> : null }
                    </div>
                    <div className="Gachapon--Selector--Bar-Count">
                        You currently have {sortedRabbits.length} rabbit{sortedRabbits.length!=1 ? "s" : ""}
                    </div>
                </div>
                <button className='Gachapon--Selector--Close' onClick={() => { clickSound(); hideSelector(); setSpinAll(false) }}>x</button>
                {!isSpinnAll ? <div className="Gachapon--Selector--Items">
                <Scrollbars style={{ width: '100%', height: '100%' }}>

                    {sortedRabbits && sortedRabbits.map((i:any, index:number) => {
                        return <RabbitItem isSpinning={false} key={index} nextSpin={nextSpin} rabbitObj={i} isSelected={(selectedRabbit === i)} toggleSelected={(rabbit:Rabbit) => { clickSound(); selectRabbit(rabbit); hideSelector() }}   />
                    })}
                </Scrollbars>
                </div> : null}
                {isSpinnAll ? <div className="Gachapon--Selector--All">
                                    
                                <div className='Gachapon--Selector--All-Rabbit'>
                                <Scrollbars style={{ width: '100%', height: '100%' }}>
                                    {rabbits && rabbits.map((i:any, index:number) => {
                                        return <RabbitItem isSpinning={spinRabbit && i.mint === spinRabbit!.mint} key={index} nextSpin={nextSpin} rabbitObj={i} isSelected={(selectedRabbit === i)} toggleSelected={(rabbit:Rabbit) => { clickSound(); selectRabbit(rabbit); hideSelector() }}   />
                                    })}
                                </Scrollbars>
                                </div>
                                <div className='Gachapon--Selector--All-History'>
                                {spinRabbitHistory.length == 0 ? <span className='Gachapon--Selector--All-button' onClick={() => { spinAll(rabbits) }}>Spin all</span> : <div className='Gachapon--Selector--All-Title'><span>Spins history</span><span>{rabbits.filter((i:any) => { return i.spins_remaining === 0}).length} of {rabbits.length}</span></div> }
                                    { spinRabbitHistory && spinRabbitHistory.map((spin:any, index:number) => {
                                        return  <div key={index} className='Gachapon--Selector--All-History-Item'>
                                            <span><img src={spin?.currentRabbit.metadata.image} style={{width: 50}}/></span>
                                            <span>{spin.currentRabbit.metadata.name}</span>
                                            <span>{spin.name}</span>
                                            
                                            <span><img src={spin?.image} style={{width: 50}}/></span>
                                        </div>
                                    })}
                                    
                                </div>
                            </div> : null}
                
            </div>
        </div>
    )
}

export default RabbitSelector;